<template>
    <div class='tops_body'>
        <div class="reserve-complete-body">
            <h2 class='reserve-accent-title font-weight-bold mb-4 bg-single'>{{ wordingType }}完了</h2>
            <h3 class='reserve-complete-message font-weight-bold text-center bg-single'>{{ wordingTypeSecond }}</h3>
            <h4 class='content text-center mb-2 bg-single'>{{ wordingType }}番号はお問い合わせの際に必要となりますのでお控えください。</h4>
            <h4 class='content text-center bg-single'>また、確認のメールをお送りしましたので内容をご確認ください。</h4>
            <h4 class='content text-center bg-single'>
                {{ wordingType }}番号
                <span class="font-weight-bold bg-single">{{ reserveNo }}</span>
            </h4>
            <div class="row justify-content-center my-4 mx-1">
                <div class="btn nextBtn col-sm-3" v-show="showCompanionButton" @click='onNext'>{{ nextBtnName }}</div>
            </div>
            <div class="row justify-content-center my-4 mx-1">
                <div class="btn nextBtn col-sm-3" v-if="mobileAppHidden === false" @click='onMypage'>マイページ</div>
            </div>
        </div>
    </div>
</template>

<script>
import { CODE_MASTER } from '../../config';
import { GET_PLAY_TOGETHER_FIXED_DEADLINE } from '../../constants/golf_course';

export default {
    components: {
    },
    data () {
        return {
            // 予約番号
            reserveNo: null,
            reserveType: 1,
            wordingType: null,
            wordingTypeSecond: null,
            nextBtnName: null,
            // 同伴者登録ボタン表示切り替えフラグ
            showCompanionButton: false,
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false
        };
    },
    created () {
        this.initialize();
        this.playTogetherFixedDeadline();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            // モバイルアプリか判断する
            if (this.$store.state.auth.mobileAppFlag) {
                // モバイルアプリの場合、遷移ボタンを非表示にする
                this.mobileAppHidden = true;
            }
            // セッションから予約番号と予約種別（通常、リクエスト）を取得
            this.reserveNo = sessionStorage.getItem('Reserve.reserveNo');
            this.reserveType = sessionStorage.getItem('Reserve.reserveType');
            sessionStorage.removeItem('Reserve.groupInfo');

            // 予約番号と予約種別が取得できない場合は予約のTOPへ
            if (this.reserveNo == null || this.reserveType == null) {
                history.pushState(null, null, "/reserve");
                this.$router.push("/reserve");
                return;
            }

            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_REQUEST && !sessionStorage.getItem('MyPage.reserveBranchNo')) {
                this.wordingType = 'リクエスト';
                this.wordingTypeSecond = 'リクエストが完了致しました。';
                this.nextBtnName = 'トップへ戻る';
            } else if (sessionStorage.getItem('MyPage.reserveBranchNo')) {
                this.wordingType = '予約';
                this.wordingTypeSecond = 'ご予約の変更を受付致しました。';
                this.nextBtnName = '同伴者登録';
            } else {
                this.wordingType = '予約';
                this.wordingTypeSecond = 'ご予約が完了致しました。';
                this.nextBtnName = '同伴者登録';
            }
        },

        /** ----------------------------------------------
         * 同伴者の変更締め切りの確認
         * 設定された締め切り日の当日以降であればfalseを返す
         * ---------------------------------------------- */
        playTogetherFixedDeadline: async function () {
            try {
                let res = await this.$apollo.query({
                    query: GET_PLAY_TOGETHER_FIXED_DEADLINE,
                    fetchPolicy: 'no-cache',
                    variables: {
                        reserve_no: this.reserveNo
                    }
                });
                // 99は期限なしなので処理終わり
                if (res.data.GetPlayTogetherFixedDeadline[0].play_together_fixed_deadline == 99) {
                    this.showCompanionButton = true;
                    return;
                }
                const today = new Date();
                const playDate = new Date(res.data.GetPlayTogetherFixedDeadline[0].play_date);
                const playDateYear = playDate.getFullYear();
                let playDateMonth = playDate.getMonth() + 1;
                let playDateDate = playDate.getDate();
                var limitDay = new Date(playDateYear, playDateMonth - 1, playDateDate - res.data.GetPlayTogetherFixedDeadline[0].play_together_fixed_deadline);
                if (today >= limitDay) {
                    this.showCompanionButton = false;
                } else {
                    this.showCompanionButton = true;
                }
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 同伴者登録ボタン処理
         * ---------------------------------------------- */
        onNext() {
            // リクエストの場合
            if (this.reserveType == CODE_MASTER.RESERVE_TYPE_REQUEST ) {
                // 予約トップへ
                this.$router.push("/reserve");
            } else {
                sessionStorage.setItem('Reserve.reserveEdit', 0);
                // 同伴者登録画面へ
                this.$router.push("/companion-list");
            }
        },
        onMypage() {
            this.$router.push('/mypage');
        },
    }
}

</script>

<style scoped>
</style>
